import './index.scss';
import { createRoot } from 'react-dom/client';
import AppComponent from './AppComponent';

// import reportWebVitals from './reportWebVitals';=

const container = document.getElementById('root');

if (!container)
  throw new Error("Container element with id 'root' is missing in HTML.");

const root = createRoot(container);

root.render(
  // TODO: Strict mode causes double renders of components and causes POST requests being sent twice. That is causing errors and unexpected behavior. Investigate, how to solve this.
  // <React.StrictMode>
  <AppComponent />,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
